<mat-toolbar class="one-header" [ngClass]="{'in-detail': isInDetail == true}">
    <mat-toolbar-row class="header-row">
        <mat-icon class="back" aria-label="Arrow left icon" (click)="onBack()">keyboard_arrow_left</mat-icon>
        <h2 class="title" (click)="onBack()">{{title}}</h2>
        <button mat-icon-button class="refresh" (click)="onRefresh()">
            <mat-icon class="renew-icon" [ngClass]="{'spin': refreshing}">autorenew</mat-icon>
        </button>
        <div class="one-spacer"></div>
        <button class="side" mat-stroked-button (click)="slideSearchBar(true)">{{text.SEARCH_TEXT}}
            <mat-icon aria-hidden="false" aria-label="Arrow right icon">keyboard_arrow_right</mat-icon>
        </button>
    </mat-toolbar-row>
    <mat-toolbar-row class="header-row overflow-x">
        <nav mat-tab-nav-bar class="one-tab-nav-bar">
            <a mat-tab-link class="one-tab" [active]="isFilterAll" (click)="onFilter()">{{text.FILTER.ALL}}</a>
            <a mat-tab-link class="hidden one-tab">{{text.FILTER.IN_TURN}}</a>
            <a mat-tab-link class="one-tab" [active]="isOverdue"
                (click)="onFilter('Timeout')">{{text.FILTER.OVERDUE}}</a>
            <a mat-tab-link class="one-tab" [active]="isPending"
                (click)="onFilter('Pending')">{{text.FILTER.WAITING}}</a>
            <a mat-tab-link class="one-tab" [active]="isApproved"
                (click)="onFilter('Approved')">{{text.FILTER.APPROVED}}</a>
            <a mat-tab-link class="one-tab" [active]="isRejected"
                (click)="onFilter('Rejected')">{{text.FILTER.REJECTED}}</a>
            <a mat-tab-link class="one-tab" [active]="isCancelled"
                (click)="onFilter('Cancelled')">{{text.FILTER.CANCELLED}}</a>
            <a mat-tab-link *ngIf="filter.requestGroup" class="one-tab" (click)="onEditGroup()">Chỉnh sửa</a>
        </nav>
      <div class="one-spacer"></div>
      <button mat-icon-button class="export-excel-btn" [ngClass]="{hidden: !isInFilter}" (click)="exportExcelFiles()">
        <mat-icon class="renew-icon" [ngClass]="{'spin': refreshing}">import_export</mat-icon>
        Xuất Excel
      </button>
    </mat-toolbar-row>
</mat-toolbar>

<div class="right-bar active" *ngIf="opened && !isInDetail">
    <div class="header">
        <div class="title">{{text.SEARCH_TEXT}}</div>
        <div class="close js-close" (click)="slideSearchBar(false)">
            <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon>
        </div>
    </div>
    <div class="body">
        <div class="filter-container">
            <form [formGroup]="filterFormGroup">
                <div class="filter-item">
                    <div class="name">Tên </div>
                    <mat-form-field class="full" appearance="outline" color="warn">
                        <mat-label>Tên</mat-label>
                        <input matInput placeholder="Tên" formControlName="name">
                    </mat-form-field>
                </div>
                <div class="filter-item">
                    <div class="name">Trạng thái </div>
                    <mat-form-field appearance="fill" class="full">
                        <mat-select formControlName="status" #singleSelect>
                            <mat-option *ngFor="let status of statuses" [value]="status.value">
                                {{status.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="filter-item">
                    <div class="name">Tạo bởi </div>
                    <one-user-select [allUsers]="users" [oneControl]="filterFormGroup.controls.submitters"></one-user-select>
                </div>
                <div class="filter-item">
                    <div class="name">Thời gian tạo </div>
                    <mat-form-field appearance="fill">
                        <mat-label>Thời gian tạo</mat-label>
                        <mat-date-range-input [formGroup]="filterFormGroup.controls.submitTime" [rangePicker]="picker">
                            <input matStartDate formControlName="start" placeholder="Start date">
                            <input matEndDate formControlName="end" placeholder="End date">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </form>
        </div>
    </div>
    <div class="footer">
        <button class="btn-update" mat-stroked-button (click)="updateFilter()">Cập nhật</button>
    </div>
</div>
